import { __localesModel, __localizedField } from "@/Utils/locales";
export const models = {
  locales: __localesModel,
  business_id: null
};
export const options = {
  typeOptions: []
};

export const Fields = [
  __localizedField,
  {
    type: "select",
    name: "type",
    label: "type",
    value: "",
    rules: "required",
    options: [],
    validationMessage: {
      required: "Select type please"
    },
    xl: "12"
  }
];
